import moment from "moment"

export const getTimeDifferenceFromNow = (date: Date): string => {
    return moment(date).fromNow();
}